import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import Labels from 'Skelet/src/components/Labels.js'
import ModalCreatePipeline from './ModalCreatePipeline.js'
import ModalUpdatePipeline from './ModalUpdatePipeline.js'
import refresh_icon from './28406.svg';


class Pipelines extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0, modal_create_open:false, modal_update_open:false, modal_content:{}};

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "pipeline_list", "GET", config.api_url+"/pipeline-list?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
      this.props.fetchDataIfReady(config.api_token, "label_list", "GET", config.api_url+"/label-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "pipeline_list", "GET", config.api_url+"/pipeline-list?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "label_list", "GET", config.api_url+"/label-list?t="+nextProps.session_token);
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleScroll(e) {
    let window_bottom = window.pageYOffset + window.innerHeight;
    let list_bottom = this.wrapperRef.offsetTop + this.wrapperRef.scrollHeight;
    if (window_bottom >= list_bottom) {
      let page_cards = this.props.apiData["pipeline_list"];
      if(page_cards !== undefined && !page_cards.isFetching && !page_cards.limitReached) {
        let new_page = (this.state.page+1);
        this.setState({page:new_page});
        this.props.fetchDataIfReady(config.api_token, "pipeline_list", "GET", config.api_url+"/pipeline-list?t="+this.props.session_token, undefined, {"PM-List-Page":new_page}, false, true);
      }
    }
  }

  render() {
    let card = null, cards = null, end_of_list_text = "", page_cards = this.props.apiData["pipeline_list"], label_list = this.props.apiData["label_list"];
    if(page_cards !== undefined && label_list !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        return <div key={"1k"+i} style={{marginBottom:"14px"}}><Link to={"/pipeline/"+item.name}><div className="contact notification">
          <div className="contact-name">{item.name}</div>
          <Labels label_list={label_list} item_labels={item.labels} displayMode />
          <span className="btn" onClick={(e) => openModal(this, e, item, "modal_update_open")}>edit</span>
        </div></Link></div>;
      }.bind(this));
      card = <div className="card Pipelines">{cards}</div>;
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Laden..";
    } else if((page_cards !== undefined && !page_cards.isFetching && page_cards.limitReached)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "End of results.";
      } else {
        end_of_list_text = "No pipelines.";
      }
    }

    return (
      <div className="container content" ref={(node) => this.setWrapperRef(node)}>
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Pipelines</strong></div>
          <div className="card-layout-div50 index-actions">
            {page_cards !== undefined && <button className="btn" style={{marginRight:"10px"}} onClick={() => openModal(this, null, null, "modal_create_open")}>New</button>}
            <img src={refresh_icon} alt="Refresh" onClick={() => this.refresh()}/>
          </div>
        </div>
        {card}
        <div className="end_of_list_text">{end_of_list_text}</div>

        <ModalUpdatePipeline shouldShow={this.state.modal_update_open} close={() => closeModal(this, "modal_update_open")} update_data={this.state.modal_content} label_list={this.props.apiData["label_list"]} />
        <ModalCreatePipeline shouldShow={this.state.modal_create_open} close={() => closeModal(this, "modal_create_open")} label_list={this.props.apiData["label_list"]} />
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("pipeline_list");
    this.props.clearStateBlock("label_list");
    this.setState({"page":0});  
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Pipelines)



// WEBPACK FOOTER //
// ./src/containers/Pipelines.js